module.exports = __webpack_public_path__ + "img/30.f92a37be.jpg";